export default __webpack_public_path__ + "static/media/banner.310f164e.png";